export function getFutureTimestamp(secondsLeft: number): number {
	const secondsLeftInMs = secondsLeft * 1000;
	return Date.now() + secondsLeftInMs;
}

export function getSecondsElapsedFromTimestamp(timestamp: number) {
	const differenceInMs = timestamp - Date.now();
	const secondsElapsed = Math.floor(differenceInMs / 1000);
	if (secondsElapsed <= 0) return 0;
	return secondsElapsed;
}
